// src/data/appRegistry.js

// Registry of app views that can be resolved by /app/:viewId.
// This is not a navigation registry.
// It does not decide what appears in the sidebar, dashboard, or catalog.
// It only tells DynamicAppView which component should be loaded for a view id.

// Veure idees que tinc a toolkitData.js
// Valorar si posar funcionalitats que hi ha aquí https://www.tolvan.com/
// https://ki.se/en/people/svante-granqvist
// https://sites.google.com/site/jangsvec/

// TODO afegir recurs que calibri les intensitats en funció de una com fa el Svante Granqvist, programa sopran
// Jan Svec tutorial measurement sound pressure level

import {
  INTERNAL_VOCAL_ROUTINE_FOUNDER_USER_ID
} from '../internal/vocal-routine/vocalRoutineAccess';
import { GLOBAL_USER_ROLES } from '../constants/globalUserRoles';

export const appRegistry = [
  // ============================================================
  // Core app views
  // ============================================================

  {
    id: "dashboard",
    labelKey: "dashboard",
    icon: "dashboard",
    route: "/app",
    component: "AppDashboard",
    allowedRoles: GLOBAL_USER_ROLES,
    showInSidebar: true,
    sidebarVariant: "primary",
    sidebarOrder: 10
  },

  {
    id: "catalog",
    labelKey: "catalog",
    icon: "library",
    route: "/app/catalog",
    component: "AppCatalogPage",
    allowedRoles: GLOBAL_USER_ROLES,
    showInSidebar: true,
    sidebarVariant: "primary",
    sidebarOrder: 20
  },

  {
    id: "participate",
    labelKey: "participate",
    icon: "inbox",
    route: "/app/participate",
    allowedRoles: GLOBAL_USER_ROLES,
    showInSidebar: true,
    sidebarVariant: "primary",
    sidebarOrder: 22
  },

  {
    id: "facilitate",
    labelKey: "facilitate",
    icon: "send",
    route: "/app/facilitate",
    allowedRoles: GLOBAL_USER_ROLES,
    showInSidebar: true,
    sidebarVariant: "primary",
    sidebarOrder: 25
  },

  {
    id: "assignments",
    labelKey: "assignments",
    icon: "assessment",
    route: "/app/assignments",
    component: "FacilitatorAssignmentsPage",
    allowedRoles: GLOBAL_USER_ROLES,
    showInSidebar: false,
    sidebarVariant: "primary",
    sidebarOrder: 26
  },

  {
    id: "profile",
    labelKey: "profile",
    icon: "user",
    route: "/app/profile",
    component: "UserProfilePage",
    allowedRoles: GLOBAL_USER_ROLES,
    showInSidebar: true,
    sidebarVariant: "primary",
    sidebarOrder: 30
  },

  {
    id: "admin",
    labelKey: "admin",
    icon: "construction",
    route: "/app/admin",
    component: "AdminDashboard",
    allowedRoles: ["admin"],
    showInSidebar: true,
    sidebarVariant: "primary",
    sidebarOrder: 40
  },

  {
    id: "internal-vocal-routine",
    labelKey: "internal_vocal_routine",
    route: "/app/internal-vocal-routine",
    component: "InternalVocalRoutinePage",
    allowedRoles: ["admin"],
    allowedUsers: INTERNAL_VOCAL_ROUTINE_FOUNDER_USER_ID
      ? [INTERNAL_VOCAL_ROUTINE_FOUNDER_USER_ID]
      : [],
    showInSidebar: false
  },

  // ============================================================
  // Admin workspace
  // ============================================================

  {
    id: "strategy",
    labelKey: "strategy",
    component: "StrategyDashboard",
    allowedRoles: ["admin"]
  },

  {
    id: "analytics",
    labelKey: "analytics",
    component: "AnalyticsDashboard",
    allowedRoles: ["admin"]
  },

  {
    id: "science",
    labelKey: "science",
    component: "ScienceDashboard",
    allowedRoles: ["admin"]
  },

  {
    id: "docs",
    labelKey: "docs",
    component: "DocumentationPage",
    allowedRoles: ["admin"]
  },

  {
    id: "workstreams",
    labelKey: "workstreams",
    component: "WorkstreamsPage",
    allowedRoles: ["admin"]
  },

  {
    id: "deadlines",
    labelKey: "deadlines",
    component: "DeadlinesBoard",
    allowedRoles: ["admin"]
  },

  {
    id: "maps",
    labelKey: "maps",
    component: "MapsView",
    allowedRoles: ["admin"]
  },

  {
    id: "icon-gallery",
    labelKey: "icon_gallery",
    component: "IconGallery",
    allowedRoles: ["admin"]
  },

  {
    id: "demo",
    labelKey: "demo",
    component: "StudentPerformanceAnalyticsDemo",
    allowedRoles: ["admin"]
  },

  //////////////////////////////////////////////////////////////
  // ============================================================
  // CATALOG ACTIVITIES
  // ============================================================
  //////////////////////////////////////////////////////////////

  // ============================================================
  // 2AFC
  // ============================================================

  { id: "2afc-overall-severity", component: "Attribute2AFC_Overall" },
  { id: "2afc-roughness", component: "Attribute2AFC_Roughness" },
  { id: "2afc-breathiness", component: "Attribute2AFC_Breathiness" },
  { id: "2afc-strain", component: "Attribute2AFC_Strain" },
  { id: "2afc-random", component: "Attribute2AFC_Random" },

  // ============================================================
  // Practice
  // ============================================================

  { id: "overall-severity-random-practice", component: "OSRandomPractice" },
  { id: "overall-severity-select-practice", component: "OSSelectPractice" },

  { id: "capev-random-practice", component: "CAPEVRandomPractice" },
  { id: "capev-select-practice", component: "CAPEVSelectPractice" },

  { id: "capevr-random-practice", component: "CAPEVrRandomPractice" },
  { id: "capevr-select-practice", component: "CAPEVrSelectPractice" },
  {
    id: "engine-standalone-random-practice",
    component: "EngineStandaloneRandomPracticePage"
  },
  {
    id: "engine-standalone-select-practice",
    component: "EngineStandaloneSelectPracticePage"
  },
  {
    id: "engine-live-moderate-session",
    component: "EngineLiveModeratorPage"
  },
  { id: "grbas", component: "GRBASStandalonePage" },

  // ============================================================
  // Interactive sessions
  // ============================================================

  { id: 'overall-severity-session', labelKey: 'overall_severity', component: 'OverallSeveritySessionParent' },
  { id: 'capev-session', labelKey: 'cape_v', component: 'CAPEvSessionParent' },
  { id: 'capevr-session', labelKey: 'cape_vr', component: 'CAPEvrSessionParent' },
  { id: 'join-a-session', labelKey: 'join_a_session', component: 'JoinSessionParent' },

  // ============================================================
  // Play
  // ============================================================

  { id: "guess-the-diagnosis", component: "GuessTheDiagnosis" },
  
  // ============================================================
  // Upload a sample
  // ============================================================

  { id: 'overall-severity-upload', labelKey: 'overall_severity_upload', component: 'OSUpload' },
  { id: 'capev-upload', labelKey: 'capev_upload', component: 'CAPEVUpload' },
  { id: 'capevr-upload', labelKey: 'capevr_upload', component: 'CAPEVrUpload' },
  { id: "grbas-upload", component: "GRBASLocalUploadPage" },

  // ============================================================
  // Record
  // ============================================================

  { id: 'capevr-record', labelKey: 'capevr_recorder_tool', component: 'CapevrRecorderTool' },
  { id: 'vrp-record', labelKey: 'vrp_recorder_tool', component: 'VrpRecorderTool' },

  // ============================================================
  // Conceptualize
  // ============================================================

  { id: 'artistic-voices', labelKey: 'attributes_categorization_title', component: 'ClinicalTaxonomyArtisticVoice' },
  { id: 'perceptual_attributes_categorization', labelKey: 'perceptual_attributes_categorization', component: 'PerceptualAttributesCategorization' },
  { id: 'general_voice_categorization', labelKey: 'general_voice_categorization', component: 'GeneralVoiceConceptsCategorization' },

  // ============================================================
  // Coding
  // ============================================================
       
  { id: 'overall-severity-record-or-upload', labelKey: 'os_record_or_upload', component: 'OSRecordComingSoon' },
  { id: 'capev-record-or-upload', labelKey: 'capev_record_or_upload', component: 'CAPEVRecordComingSoon'},
  { id: 'capevr-record-or-upload', labelKey: 'capevr_record_or_upload', component: 'CapeVrTool' },
  { id: 'sustained-a', labelKey: 'sustained_a', component: 'SustainedAAnalysisTool' },
  { id: 'vrp', labelKey: 'vrp', component: 'VoiceRangeProfileTool' },
  { id: 'mpt-sz', labelKey: 'mpt_sz', component: 'MptSzTool' },
  { id: 'proms', labelKey: 'proms', component: 'PromsTool' },
  { id: 'wvd-marathon', labelKey: 'wvd_marathon', component: 'WVDEvent' },
  { id: 'research_methodology', labelKey: 'research_methodology', component: 'ResearchMethodologyGrid' },
  { id: 'anchors', labelKey: 'anchors', component: 'Anchors', allowedRoles: ['admin'] },
  { id: 'resource_builder', labelKey: 'resource_builder', component: 'ResourceBuilder' },
  { id: 'concept_manager', labelKey: 'concept_manager', component: 'ConceptManager' },
  { id: 'earv', labelKey: 'earv', component: 'EARV' },
  { id: 'vas_experiment', labelKey: 'vas_experiment', component: 'VASexperiment' },
  { id: 'concepts_free_sorting_task', labelKey: 'concepts_free_sorting_task', component: 'ConceptsFreeSortingTask' },
  { id: 'free_sorting_task', labelKey: 'free_sorting_task', component: 'FreeSortingTask' },
  { id: 'collections_sorting_task', labelKey: 'collections_sorting_task', component: 'CollectionsFreeSortingTask' },
  { id: 'training_phases', labelKey: 'training_phases', component: 'TrainingPhases' },
  { id: 'random_vas_experiment', labelKey: 'random_vas_experiment', component: 'RandomVASexperiment' },
  { id: '2afc_experiment', labelKey: '2afc_experiment', component: 'TwoAFCexperiment' },
  { id: 'vas-attribute-rating', labelKey: 'vas_attribute_rating', component: 'VASAttributeRating' },
  { id: 'hierarchical-ordering', labelKey: 'hierarchical_sample_ordering', component: 'HierarchicalOrdering' },     
  { id: 'drag-samples-into-categories', labelKey: 'drag_samples_into_categories', component: 'DragToCategories' },
  { id: 'self-assessment-feedback', labelKey: 'self_assessment_with_feedback', component: 'SelfAssessmentFeedback' },
  { id: 'perceptual-map-2d', labelKey: 'place_on_2d_perceptual_map', component: 'PerceptualMap2D' },
  { id: 'perception-to-spectrogram', labelKey: 'match_perception_to_spectrogram', component: 'PerceptionToSpectrogram' },
  { id: 'before-after-sample-comparison', labelKey: 'before_after_sample_comparison', component: 'BeforeAfterComparison' },
  { id: 'auditory-memory-training', labelKey: 'auditory_memory_training', component: 'AuditoryMemoryTraining' },
  { id: 'free-exploration-annotation', labelKey: 'free_exploration_and_guided_annotation', component: 'FreeExplorationAnnotation' },
  { id: 'guess-the-spectrum', labelKey: 'guess_the_spectrum_title', component: 'GuessTheSpectrum' },
  { id: 'guess-the-spectrogram', labelKey: 'guess_the_spectrogram_title', component: 'GuessTheSpectrogram' },
  { id: 'guess-the-parameters', labelKey: 'guess_the_acoustic_parameters_title', component: 'GuessTheParameters' },
  { id: 'guess-the-ring', labelKey: 'guess_the_ring_title', component: 'GuessTheRing' },

];
